import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=65c2a372&scoped=true&"
import script from "./ItemsList.vue?vue&type=script&lang=js&"
export * from "./ItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=65c2a372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_bd47uzbtgolpottv4tyra2y574/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2a372",
  null
  
)

export default component.exports